import * as React from 'react'
import { useTranslation } from 'react-i18next'
import BizzeyLogo from '../../components/BizzeyLogo'

export default function PoweredBy() {
  const { t } = useTranslation()

  return (
    <a
      href='https://www.bizzey.com'
      target='_blank'
      rel='noopener noreferrer'
      className='mx-auto flex w-fit items-center gap-2 py-4 text-xs text-muted-foreground transition-colors hover:text-foreground'
    >
      <span>{t('PoweredBy::Powered by')}</span>
      <BizzeyLogo className='h-5 w-auto text-foreground' />
    </a>
  )
}
